const workerText2 =
"Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio eaque porro pariatur quam impedit explicabo aspernatur, blanditiis assumenda fuga autem et, eum unde nobis. Quaerat accusamus iure quod delectus molestias.";

export default workerText2